import React, { useMemo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'constants/RoutePaths';
import { fetchAuthSession, decodeJWT } from 'aws-amplify/auth';
import { useAddEditUserMutation } from 'app/api/usersApiSlice';

const SignInRedirect = () => {
  const navigate = useNavigate();

  // Get redirect from state
  const postLoginRoute = localStorage.getItem('postSignInPath');

  const [isLoading, setIsLoading] = useState(true);

  const [
    addEditUser,
    {
      data: addEditUserData,
      isLoading: isAddEditUserLoading,
      isError: isAddEditUserError,
      isSuccess: isAddEditUserSuccess,
    },
  ] = useAddEditUserMutation();

  useEffect(() => {
    const getSession = async () => {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();

        if (token) {
          // update user and set state
          addEditUser();
        } else {
          // handle no token case
        }
        setIsLoading(false);
      } catch (error) {
        console.log('Error fetching JWT token:', error);
      }
      if (postLoginRoute) {
        navigate(postLoginRoute);
        navigate(0);
      } else {
        navigate(`/${ROUTES.HOME}`);
      }
    };
    getSession();
  }, []);

  return <div>Redirecting...</div>;
};

export default SignInRedirect;
